import { ReactNode } from 'react'

export const StyleSelector = ({
  title,
  icon,
}: {
  title: string
  icon: ReactNode
}) => (
  <div className="w-full flex gap-2 items-center justify-between">
    <div>{title}</div>
    {icon}
  </div>
)
